import React from "react";
import { Trans } from "react-i18next";

const LbCheckBox = ({
  i18nKey = "Common.AcceptRules",
  name = "",
  id = "",
  dataTip = "",
  dataFor = "",
  checked = undefined,
  error = false,
  onLabelClick = () => {},
  onChange = () => {},
  onBlur = () => {},
}) => {
  return (
    <label
      className={`agreement-terms__checkbox ${error ? " is-red " : ""}`}
      htmlFor={id}
      data-tip={dataTip}
      data-for={dataFor}
      // onClick={onLabelClick}
    >
      <input
        type="checkbox"
        name={name}
        // id={id}
        checked={checked}
        onBlur={onBlur}
        onClick={onLabelClick}
        onChange={onLabelClick}
      />
      <span onClick={onLabelClick}>
        <Trans i18nKey={i18nKey} />
      </span>
    </label>
  );
};

export default LbCheckBox;
